import PropTypes from 'prop-types';
import React, { Fragment, useEffect, useState } from 'react';
import { Button, Container, Image, Modal, Row, Table } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
// import OrderTrackMain from "./OrderTrackMain";
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { withRouter } from 'react-router-dom';
import { logOutUser } from '../../../store/actions/authAction';
import { get_menu_items } from '../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction';
import {
  GET_VENDOR_MENU_CATEGORY_ITEMS,
  SET_ACTIVE_ITEM_ID_MENU_SETUP,
  BUSINESS_DETAILS_STEP,
  ACTIVE_MENU,
} from '../../../store/types';
import { AmealioLoader } from '../../Loader/AmealioLoader';
import BasicPagination from '../../Pagination/Pagination';
import LeftSideNavigation from '../navigationSection/LeftSideNavigation';
import RightSideNavigation from '../navigationSection/RightSideNavigation';
import { TopNavigationBarMobile } from '../navigationSection/TopNavigationBarMobile';
import FiltersSection from './FiltersSection';
import MobileFilterSection from './MobileFilterSection';
import TableBody from './ItemAvailabilitytables/TableBody';
import { TableHead } from './ItemAvailabilitytables/TableHead';
import SubNavigationItemAvailability from './SubNavigationItemAvailability';
import BottomNavigationMobile from '../navigationSection/BottomNavigationMobile';
import Media from 'react-media';
import ItemAvailabilityTableBody from './ItemAvailabilityTableBody';
import Scrollbars from 'react-custom-scrollbars';
import { get_list_of_custom_menu_data } from '../../../store/actions/VendorSubscriptionAction/vendorSubscriptionPostAction';

const ItemAvailability = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [customMenuList, setCustomMenuList] = useState([]);

  const [search, setSearch] = useState('');
  const onChangeSearch = (e) => {
    setSearch(e);
  };

  const [page, setPage] = useState(1);
  // var page = 1;

  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    let calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };
  const onSuccess = () => {
    setLoading(false);
  };

  const [availability, setAvailability] = useState('');
  const [status, setStatus] = useState('All');
  const [itemTags, setItemTags] = useState('');
  const [activeService, setActiveService] = useState('');
  const [cuisineType, setCuisineType] = useState('');
  const [activeMenu, setActiveMenu] = useState(null);
  const [switchMenu, setswitchMenu] = useState(false);
  const handleSwitchMenu = () => setswitchMenu(true);
  const handleCloseSwitchMenu = () => setswitchMenu(false);

  useEffect(() => {
    if (props.serviceType.vendor_id) {
      props.get_list_of_custom_menu_data(props?.serviceType?.vendor_id);
    }
  }, [props?.serviceType]);

  useEffect(() => {
    if (props.customMenuList) {
      const updatedList = [
        {
          name: 'Standard menu',
          description: 'Standard Menu',
          _id: '123456',
          menuType: 'CUSTOM',
        },
        ...props.customMenuList,
      ];
      setCustomMenuList(updatedList);
    }
  }, [props.customMenuList]);

  const HandleMenuSelection = (item) => {
    if (item._id === '123456') {
      setActiveMenu(null);
    } else {
      setActiveMenu(item);
    }
  };

  const SetCustomMenu = (item) => {
    dispatch({
      type: ACTIVE_MENU,
      payload: item,
    });
    handleCloseSwitchMenu();
  };

  // useEffect(() => {
  //   if (props.ActiveMenu) {
  //     setShowMenu(
  //       props?.menuCategory.filter((i) => i.menu === props?.ActiveMenu?._id)
  //     );
  //   } else {
  //     setShowMenu(props.menuCategory);
  //   }
  // }, [props.menuCategory, props.ActiveMenu]);

  var filteredItems =
    (props &&
      props.all_menu_items &&
      props?.all_menu_items?.filter(
        (i) => !i.category.hasOwnProperty('menu')
      )) ||
    [];
  console.log(filteredItems);
  if (activeMenu) {
    filteredItems = props?.all_menu_items?.filter(
      (i) => i.category.menu === activeMenu?._id
    );
  }

  if (search) {
    let searchData = new RegExp(search, 'i');
    filteredItems =
      props &&
      props.all_menu_items &&
      props.all_menu_items.filter((getall) => {
        if (searchData.test(getall.name)) {
          return getall;
        } else {
          return false;
        }
      });
  }
  if (availability !== '') {
    filteredItems = filteredItems.filter((getall) => {
      return getall.availability === availability;
    });
  }
  if (availability !== '' && status === 'All') {
    filteredItems = filteredItems.filter((getall) => {
      return getall;
    });
  } else if (status === 'Active') {
    filteredItems = filteredItems.filter((getall) => {
      return getall.status === true;
    });
  } else if (status === 'Inactive') {
    filteredItems = filteredItems.filter((getall) => {
      return getall.status === false;
    });
  }
  if (itemTags !== '') {
    filteredItems = filteredItems.filter((getall) => {
      for (let i = 0; i < getall.tags.length; i++) {
        return getall.tags[i].title === itemTags;
      }
    });
  }
  if (cuisineType !== undefined && cuisineType !== null && cuisineType !== '') {
    filteredItems = filteredItems.filter((getall) => {
      return getall?.cuisin_type?.title === cuisineType;
    });
  }
  if (activeService === 'takeaway') {
    filteredItems = filteredItems.filter((getall) => {
      return getall.take_away.value === true;
    });
  } else if (activeService === 'curbside') {
    filteredItems = filteredItems.filter((getall) => {
      return getall.curb_side.value === true;
    });
  } else if (activeService === 'dinein') {
    filteredItems = filteredItems.filter((getall) => {
      return getall.dine_in.value === true;
    });
  } else if (activeService === 'skiptheline') {
    filteredItems = filteredItems.filter((getall) => {
      return getall.skip_line.value === true;
    });
  }

  /********************************************
   * @DESC Temperory local
   *******************************************/
  filteredItems = filteredItems?.filter((item) => {
    return item.is_temp_local === false || item.is_temp_local === undefined;
  });

  /********************************************
   * @DESC Sort By Category Type
   *******************************************/
  filteredItems = filteredItems?.sort((a, b) => {
    if (a?.category?.name?.toLowerCase() < b?.category?.name?.toLowerCase()) {
      return -1;
    }
    if (a?.category?.name?.toLowerCase() > b?.category?.name?.toLowerCase()) {
      return 1;
    }
    return 0;
  });

  const addNewItem = () => {
    dispatch({ type: SET_ACTIVE_ITEM_ID_MENU_SETUP, payload: '' });
    dispatch({ type: GET_VENDOR_MENU_CATEGORY_ITEMS, payload: [] });
    dispatch({ type: BUSINESS_DETAILS_STEP, payload: 1 });
    history.push({
      pathname: '/additemavailablity',
      state: {
        menuId: activeMenu?._id,
      },
    });
  };

  // useEffect(() => {
  //   const token = props.auth.user.accessToken;
  //   if (props?.all_menu_items?.length === 0 || !props?.all_menu_items) {
  //     setLoading(true);
  //     props.get_menu_items(token, onSuccess);
  //   }
  // }, [props?.all_menu_items]);

  useEffect(() => {
    const token = props.auth.user.accessToken;
    // if (props?.all_menu_items?.length === 0 || !props?.all_menu_items) {
    setLoading(true);
    props.get_menu_items(token, onSuccess);
    // }
  }, []);

  useEffect(() => {
    setPage(1);
    setStart(0);
    setEnd(10);
  }, [search]);

  const renderMobileview = () => {
    return filteredItems.slice(start, end).map((item, index) => (
      <Fragment key={index}>
        <ItemAvailabilityTableBody
          indexKey={index}
          token={props.auth.user.accessToken}
          item={item}
        />
      </Fragment>
    ));
  };

  console.log(filteredItems, 'connn');
  return (
    <React.Fragment>
      {loading ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          <div className="container-fluid superadmin-orderscomponent-main super-admin-vendor-private-orders">
            <Row>
              <div className="left-side-panel">
                <LeftSideNavigation />
              </div>
              <div className="top-panel">
                <TopNavigationBarMobile displayLeft="logo" />
              </div>
              <div className="right-side-panel">
                <RightSideNavigation
                  displayButton="itemAvailability"
                  ItemAvailabilityButton={
                    <button
                      //onClick={(e) => history.push("/additemavailablity")}
                      onClick={() => {
                        addNewItem();
                      }}
                      className="btn add_button_custom_1"
                    >
                      + Add Item
                    </button>
                  }
                  newButton={true}
                />
                <Container fluid>
                  <div className="super-admin-inside-right-side-panel">
                    <div className="seating_dashboard_top_new_header">
                      <div className="row">
                        <div className="col-12 col-md-6 my-3 my-md-0 my-lg-0 my-xl-0">
                          <h4 className="item_avaliablity f20_700_HelveticaNeue">
                            {props?.ActiveMenu
                              ? props?.ActiveMenu?.name
                              : `Standard Menu`}{' '}
                            - Item Availability Dashboard
                          </h4>
                          <div
                            className="f14-700  mx-2 my-4"
                            onClick={() => handleSwitchMenu()}
                          >
                            Switch Menu{' '}
                            <Image
                              src={require('../../../assets/images/Icon/Refresh.png')}
                            />
                          </div>
                        </div>
                        <Media query="(min-width: 992px)">
                          <div className="col-6 text-right m_view">
                            <button
                              //onClick={(e) => history.push("/additemavailablity")}
                              onClick={() => addNewItem()}
                              className="btn add_button_custom_1"
                            >
                              + Add Item
                            </button>
                          </div>
                        </Media>
                      </div>
                    </div>
                    <SubNavigationItemAvailability />
                    <Media query="(min-width: 992px)">
                      <FiltersSection
                        token={props.auth.user.accessToken}
                        search={(search) => onChangeSearch(search)}
                        availability={(data) => {
                          setAvailability(data);
                        }}
                        status={(data) => {
                          setStatus(data);
                        }}
                        itemTags={(data) => {
                          setItemTags(data);
                        }}
                        activeService={(data) => {
                          setActiveService(data);
                        }}
                        cuisineType={(data) => {
                          setCuisineType(data);
                        }}
                      />
                    </Media>
                    <Media query="(max-width: 992px)">
                      {/* <MobileFilterSection
                        token={props.auth.user.accessToken}
                        search={(search) => onChangeSearch(search)}
                      /> */}
                      <FiltersSection
                        token={props.auth.user.accessToken}
                        search={(search) => onChangeSearch(search)}
                        availability={(data) => {
                          setAvailability(data);
                        }}
                        status={(data) => {
                          setStatus(data);
                        }}
                        itemTags={(data) => {
                          setItemTags(data);
                        }}
                        activeService={(data) => {
                          setActiveService(data);
                        }}
                        cuisineType={(data) => {
                          setCuisineType(data);
                        }}
                      />
                    </Media>
                    <Media query="(min-width: 992px)">
                      <div className="col-12 p-0  user-table-reusable-superadmin ">
                        <Table responsive>
                          <thead>
                            <TableHead />
                          </thead>
                          {filteredItems
                            .slice(start, end)
                            .map((item, index) => (
                              <Fragment key={index}>
                                {/* {!item.is_temp_local ? ( */}
                                <TableBody
                                  token={props.auth.user.accessToken}
                                  item={item}
                                />
                                {/* ) : (
                                  <> </>
                                )} */}
                              </Fragment>
                            ))}
                        </Table>
                      </div>
                    </Media>

                    {/*******************************
                     *  @DESC Pending Mobile View
                     *******************************/}
                    <Media query="(max-width: 991px)">
                      <>
                        <div className="row seating-dashboard-table">
                          <div
                            className="col-3 mpr-1"
                            style={{ textAlign: 'center' }}
                          >
                            <p className="f12-500">Item ID</p>
                          </div>
                          <div className="col-3  mpr-1">
                            <p className="f12-500">Item Name</p>
                          </div>
                          <div className="col-3 mpl-1">
                            <p className="f12-500">Status</p>
                          </div>
                          <div className="col-3 mpl-1">
                            <p className="f12-500">Availability</p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12 p-0">
                            <Accordion>{renderMobileview()}</Accordion>
                          </div>
                        </div>
                      </>
                    </Media>
                    {filteredItems.length > 0 ? (
                      <BasicPagination
                        totalRecords={filteredItems.length}
                        limit={10}
                        batch={page}
                        onBatchChange={(e) => handleBatchChange(e)}
                      />
                    ) : (
                      <> </>
                    )}
                  </div>
                </Container>
              </div>
              {/* <div className="bottom-panel"></div> */}
              <Media query="(max-width: 991px)">
                <div className="bottom-panel">
                  <BottomNavigationMobile />
                </div>
              </Media>
            </Row>
          </div>
          <Modal
            show={switchMenu}
            onHide={handleCloseSwitchMenu}
            centered
            className="xl-width-750 selectCatalogueModal"
          >
            <Modal.Header className="px-4 border-0" closeButton>
              <div className="w-100">
                <Modal.Title className="f20-700 pt-2">Select Menu</Modal.Title>
              </div>
            </Modal.Header>
            <Modal.Body className="px-4">
              <div className="d-flex mobileColumn justify-content-between mx-4 mb-3">
                <p className="f14-400 ml-4">Menu Name</p>
                <p className="f14-400">Menu Description</p>
              </div>
              <div className="enGlobleCatelogueModalListMain">
                <Scrollbars style={{ width: '100%', height: 280 }}>
                  {customMenuList
                    ?.filter((i) => i.menuType === 'CUSTOM')
                    .map((item, index) => (
                      <div
                        className="d-flex align-items-center mb-4"
                        key={index}
                      >
                        {/* <Form.Check label="1" inline className="enCheckBoxOnly" /> */}
                        <label className="enRadioWithText small">
                          <input
                            type="radio"
                            name="ItemCode"
                            checked={
                              activeMenu?._id === item._id ||
                              (activeMenu == null && item._id === '123456')
                            }
                            onClick={() => HandleMenuSelection(item)}
                          />
                          <span className="checkmark"></span>
                        </label>
                        <div className="border p-2 d-flex align-items-center justify-content-between w-100">
                          <div className="d-flex align-items-center">
                            {/* <div className="enCatelogueIconDiv">
                            <SVG
                              width="27px"
                              src={require('../../../../../../../assets/images/UserManagement/menuicon.svg')}
                            />
                          </div> */}
                            <div className="f14-500 px-3">{item?.name}</div>
                          </div>
                          <div className="d-flex align-items-center">
                            <div className="f14-500 pr-3">
                              {item?.description}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </Scrollbars>
              </div>
              <div className="d-flex mobile-center align-items-center py-4">
                <Button
                  variant="outline-secondary"
                  className="btn150px btn-lg mr-4 px-5"
                  onClick={handleCloseSwitchMenu}
                >
                  Cancel
                </Button>
                <Button
                  variant="danger"
                  className="btn150px btn-lg px-5"
                  // disabled={disabled}
                  onClick={() => SetCustomMenu(activeMenu)}
                >
                  Confirm
                </Button>
              </div>
            </Modal.Body>
          </Modal>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
ItemAvailability.propTypes = {
  logOutUser: PropTypes.func.isRequired,
  get_menu_items: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  customMenuList: PropTypes.object.isRequired,
  ActiveMenu: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  all_menu_items: state?.onboarding?.all_menu_items || [],
  customMenuList: state?.onboarding?.get_custom_menu_list || [],
  ActiveMenu: state?.onboarding?.active_menu,
  allChainCatalog: state.commonSuperAdmin.allChainCatalog,
  serviceType:
    state.onboarding && state.onboarding?.onboard_subscription_details,
});

export default connect(mapStateToProps, {
  logOutUser,
  get_menu_items,
  get_list_of_custom_menu_data,
})(withRouter(ItemAvailability));

// export default withRouter(ItemAvailability);
